import { useState } from "react";
import { workshops } from "../data/workshopsData";

export default function Workshop() {

const [zoomPoster, setZoomPoster] = useState(null);

return ( <section className="min-h-screen bg-[#0b1220] text-white pt-28 pb-24">

  <div className="max-w-7xl mx-auto px-6">

    <div className="space-y-14">

      {workshops.map((workshop, idx) => {

        const reverse = idx % 2 === 1;

        return (

          <div
            key={idx}
            className={`
            flex flex-col md:flex-row
            ${reverse ? "md:flex-row-reverse" : ""}
            items-center gap-6
            rounded-3xl
            ${idx % 2 === 0 ? "bg-white/10" : "bg-white/5"}
            backdrop-blur-xl border border-white/20
            shadow-xl p-8
            `}
          >

            {/* Poster */}
            <div className="flex justify-center w-full md:w-1/2">

              <div
                className="w-full max-w-lg aspect-square rounded-2xl overflow-hidden cursor-pointer"
                onClick={() => setZoomPoster(workshop.poster)}
              >
                <img
                  src={workshop.poster}
                  alt={workshop.title}
                  className="w-full h-full object-contain hover:scale-105 transition"
                />
              </div>

            </div>

            {/* Content */}
            <div className="space-y-3 w-full md:w-1/2">

              <h2 className="text-2xl md:text-3xl font-semibold">
                {workshop.title}
              </h2>

              <p className="text-white/80 leading-relaxed">
                {workshop.description}
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-white/70">

                <p><strong>Date:</strong> {workshop.date}</p>
                <p><strong>Time:</strong> {workshop.time}</p>

                <p><strong>Team:</strong> {workshop.team}</p>
                <p><strong>Fee:</strong> {workshop.fee}</p>

                <p className="sm:col-span-2">
                  <strong>Venue:</strong> {workshop.venue}
                </p>

              </div>

              {workshop.contact && workshop.contact.length > 0 && (

                <div className="pt-2 text-white/70">

                  <p className="font-medium text-white">Contact</p>

                  {workshop.contact.map((c, i) => (
                    <p key={i}>
                      {c.name} —{" "}
                      <a
                        href={`tel:${c.phone}`}
                        className="text-blue-400 hover:underline"
                      >
                        {c.phone}
                      </a>
                    </p>
                  ))}

                </div>

              )}

              <a
                href={workshop.link}
                target="_blank"
                rel="noreferrer"
                className="
                inline-block mt-5
                px-7 py-3
                rounded-xl
                bg-blue-500 hover:bg-blue-600
                hover:shadow-lg hover:shadow-blue-500/30
                transition
                font-medium
                "
              >
                Register Now
              </a>

            </div>

          </div>

        );
      })}

    </div>

  </div>

  {/* Poster Zoom */}
  {zoomPoster && (
    <div
      onClick={() => setZoomPoster(null)}
      className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-6"
    >

      <img
        src={zoomPoster}
        alt="Poster"
        className="max-h-[90vh] rounded-2xl shadow-2xl"
      />

    </div>
  )}

</section>
);
}

